import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '@app/login/login.service';
import { AuthService } from '@app/shared/auth/auth.service';
import { ConfigService } from '@app/shared/auth/config.service';
import { CurrencyService } from '@app/shared/services/currency/currency.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ToastService } from '@app/shared/services/toast/toast.service';
import { finalize } from 'rxjs/operators';
import { LocalStorageService } from '@app/shared/services/local-storage/local-storage.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public isError: boolean;
  public errorMessage: string;
  public loginForm: FormGroup;
  public inputPasswordType: 'text' | 'password' = 'password';
  public isLoading = false;
  private redirectUrl: string;

  constructor(
    private readonly authService: AuthService,
    private readonly configService: ConfigService,
    private readonly currencyService: CurrencyService,
    private readonly formBuilder: FormBuilder,
    private readonly loginService: LoginService,
    private readonly translateService: TranslateService,
    private readonly route: ActivatedRoute,
    private readonly toastService: ToastService,
    private readonly router: Router,
    private readonly localStorageService: LocalStorageService,
  ) {
    this.route.queryParams.subscribe(params => {
      if (params.token) {
        this.authService.invalidateUser();
        this.localStorageService.invalidateToken();
        this.localStorageService.invalidateCurrency();
        this.configService.cleanup();
        this.authService.invalidateUser();
        this.authService.decodeGivenToken(params.token);
        this.configService.fetchClientConfig('growth').then(() => {
          this.currencyService.loadUserCurrency().then(() => {
            this.router.navigate(['home']);
          });
        });
      }
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if (params && params.redirect) {
        this.redirectUrl = params.redirect;
      }
      if (typeof params.codeExpired !== 'undefined') {
        this.toastService.showWarning('', this.translateService.instant('login.inviteCodeExpired'));
      }
    });
    this.createFormGroup();
    this.isLoading = false;
  }

  public onShowPassword(): void {
    this.inputPasswordType = this.inputPasswordType === 'password' ? 'text' : 'password';
  }

  public resetPassword(): void {
    this.router.navigate(['reset-password']);
  }

  public navigateToRegister(): void {
    window.location.href = `${environment.sweetDashboardAppUrl}/onboarding/verify-email?ref=benchmarks`;
  }

  public onLoginClick(): void {
    this.isLoading = true;
    this.loginService
      .signIn(this.loginForm.value)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe();
  }

  private createFormGroup(): void {
    this.loginForm = this.formBuilder.group({
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }
}
